import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { Button } from "sprout-ui-dom/dist/Button";
import { ItemType } from "sprout-graphql";
import { useNavigationActiveLock } from "@sprout/list-navigation";
import { getIsLargePointerDevice } from "sprout-ui-dom/dist/utils";
import { usePostPageEditor } from "../PostPageEditorContext";
import { PostPageTodoEditor } from "../PostPageEditors";
const NewTodoButton = styled(Button)`
  /* to make container 40px so it doesn't jitter */
  margin: 4px 0;
`;
/**
 * NOTE: Do not try to attempt refactoring this without knowing why it's
 * coded this way.
 *
 * `PostPageTodoList` can unmount when the `optimisticId` changes. Hence we need
 * to use `useState` to create a local state, instead of relying on the global
 * editor state.
 */ const PostPageTodoListNewButton = (props)=>{
    const { todoListId , todoListNodeId  } = props;
    const { state: { editor , editorPosition , parentId , variant  } ,  } = usePostPageEditor();
    const [open, setOpen] = useState(editor === "CREATE_TODO" && editorPosition === Number.MIN_SAFE_INTEGER ? variant : undefined);
    const handleClose = useCallback(()=>{
        setOpen(undefined);
    }, []);
    const handleClick = useCallback(()=>{
        setOpen(getIsLargePointerDevice() ? "desktop" : "mobile");
    }, []);
    const hideButton = open || editor === "CREATE_TODO" && (editorPosition === todoListId || parentId === todoListId);
    useNavigationActiveLock(typeof open !== "undefined");
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PostPageTodoEditor, {
                topicId: todoListId,
                parentId: todoListId,
                parentNodeId: todoListNodeId,
                parentType: ItemType.Checklist,
                open: open,
                onClose: handleClose
            }),
            !hideButton && /*#__PURE__*/ _jsx(NewTodoButton, {
                variant: "outline",
                size: "sm",
                onClick: handleClick,
                children: "Add a leaf"
            })
        ]
    });
};
export default PostPageTodoListNewButton;
